import type { GetOrderRequest, GetOrdersRequest } from './types';

export const ORDER_QUERY_KEYS = {
  default: () => ['order'] as const,
  getOrder: (params: GetOrderRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrder', params] as const,
  getOrders: (params?: GetOrdersRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrders', params] as const,
};

